import React, { createContext, useContext, useState } from "react";
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowDownIcon } from '@hugeicons/core-free-icons';
import { cn } from "../../lib/utils";

const AccordionContext = createContext(null);

const Accordion = ({ type = "single", collapsible = false, className, children, ...props }) => {
  const [openValue, setOpenValue] = useState(null);

  const toggleItem = (value) => {
    if (type === "single") {
      setOpenValue(openValue === value && collapsible ? null : value);
    } else {
      setOpenValue(prev => {
        const arr = Array.isArray(prev) ? prev : [];
        return arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
      });
    }
  };

  return (
    <AccordionContext.Provider value={{ openValue, toggleItem, type, collapsible }}>
      <div className={cn("w-full", className)} {...props}>{children}</div>
    </AccordionContext.Provider>
  );
};

const AccordionItem = ({ value, className, children }) => {
  const { openValue } = useContext(AccordionContext);
  const isOpen = Array.isArray(openValue) ? openValue.includes(value) : openValue === value;

  return (
    <div className={cn("border-b border-border/50", className)} data-state={isOpen ? "open" : "closed"}>
      {children}
    </div>
  );
};

const AccordionTrigger = ({ className, children, ...props }) => {
  const { openValue, toggleItem } = useContext(AccordionContext);
  const value = props["data-item-value"];
  const isOpen = Array.isArray(openValue) ? openValue.includes(value) : openValue === value;

  return (
    <button
      className={cn(
        "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline w-full",
        className
      )}
      onClick={() => toggleItem(value)}
      {...props}
    >
      {children}
      <HugeiconsIcon icon={ArrowDownIcon} size={18} className={cn("text-muted-foreground transition-transform duration-200", isOpen && "rotate-180")} />
    </button>
  );
};

const AccordionContent = ({ className, children, ...props }) => {
  const { openValue } = useContext(AccordionContext);
  const value = props["data-item-value"];
  const isOpen = Array.isArray(openValue) ? openValue.includes(value) : openValue === value;

  if (!isOpen) return null;

  return (
    <div className={cn("pb-4 pt-0 text-sm", className)} {...props}>
      {children}
    </div>
  );
};

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
